function retrieveDepositHours(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/deposit-hours`);
}

function updateDepositHours(companyId, DepositHours) {
    return window.tenantAxios.patch(`/company/${companyId}/deposit-hours`, DepositHours);
}

export default {
    retrieveDepositHours,
    updateDepositHours,
};
